export default __webpack_public_path__ + "static/media/lunch2.09df90f1.jpeg";